<template>
  <v-modal-content
    :title="t('message.cookies.cookiesManager.title')"
    hide-confirm
    v-bind="$attrs"
    with-back-icon
    @cancel="back"
  >
    <ion-content>
      <section>
        <ion-text color="dark">
          <p>
            <b>PorritaOnline</b> (en adelante, el <b>"TITULAR"</b>) informa, a través de la presente
            Política de Cookies, acerca de la utilización de dispositivos de almacenamiento y
            recuperación de datos en equipos terminales de los Usuarios.
          </p>
        </ion-text>
      </section>
      <section>
        <h3>¿Qué son las cookies?</h3>
        <ion-text color="medium">
          <p>
            Las cookies son archivos o ficheros que se descargan en el ordenador/smartphone/tablet
            del Usuario al acceder a determinadas páginas web y aplicaciones que permiten almacenar
            preferencias de la navegación del Usuario, haciendo que la interacción entre el Usuario
            y el Sitio Web sea más rápida y fácil.
          </p>
          <p>
            La información recogida por las cookies es anónima y no contiene ninguna información
            sensible ya que no recogen datos que puedan identificar personalmente al Usuario. En
            cualquier caso, el Usuario podrá acceder a la configuración de su navegador para
            modificar y/o bloquear la instalación de las Cookies enviadas desde el sitio web, sin
            que ello impida al acceso a los contenidos.
          </p>
        </ion-text>
      </section>
      <section>
        <h3>
          ¿Para qué utiliza el <span class="font-weight-bold font-italic">TITULAR</span> las
          cookies?
        </h3>
        <ion-text color="medium">
          <p>
            De conformidad con la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la
            información y de comercio electrónico (en adelante, “LSSI”), el sitio web utiliza
            cookies u otros dispositivos de almacenamiento y recuperación de información para
            realizar un seguimiento de las interacciones de los Usuarios con los servicios ofrecidos
            en el sitio web.
          </p>
          <p>
            Las <i>cookies</i> permiten reconocer el navegador de un Usuario, así como el tipo de
            dispositivo desde el que se accede al sitio web y se utilizan para facilitar la próxima
            visita del Usuario y hacer que el sitio web le resulte más útil.
          </p>
          <p>
            El <span class="font-weight-bold font-italic">TITULAR</span> utiliza las cookies para:
          </p>
          <ol class="li-space-lg hirodev-ol-red">
            <li>Optimizar la navegación del Usuario mediante el seguimiento de la sesión.</li>
            <li>Recopilar información para optimizar la navegación y mejorar el sitio web.</li>
          </ol>
        </ion-text>
      </section>
      <section>
        <p>{{ t("message.cookies.cookiesManager.cookiesUsed") }}</p>
        <ion-list>
          <ion-item>
            <ion-label class="ion-text-wrap">
              <h3>{{ t("message.cookies.cookiesManager.needed") }}</h3>
              <p>{{ t("message.cookies.cookiesManager.neededText") }}</p>
            </ion-label>
            <ion-toggle slot="end" :disabled="true" :checked="true" />
          </ion-item>
          <ion-item>
            <ion-label class="ion-text-wrap">
              <h3>{{ t("message.cookies.cookiesManager.analytics") }}</h3>
              <p>{{ t("message.cookies.cookiesManager.analyticsText") }}</p>
            </ion-label>
            <ion-toggle slot="end" v-model="acceptedAnalytics" />
          </ion-item>
        </ion-list>
      </section>
    </ion-content>
  </v-modal-content>
  <ion-footer>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button color="medium" @click="submit">{{
          t("message.cookies.cookiesManager.accept")
        }}</ion-button>
        <ion-button color="primary" @click="submitAll">{{
          t("message.cookies.cookiesManager.acceptAll")
        }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import { bootstrap } from "vue-gtag";
import { useI18n } from "vue-i18n";
import {
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonToggle,
  IonFooter,
  IonToolbar,
  IonButton,
  IonButtons,
  IonText,
  modalController,
} from "@ionic/vue";
import VModalContent from "@/common/components/VModalContent.vue";
import { useModalBack } from "@/common/composables/modal-back";
import { GA_MEASUREMENT_ID } from "@/common/constants";

export default defineComponent({
  components: {
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonToggle,
    IonFooter,
    IonToolbar,
    IonButton,
    IonButtons,
    IonText,
    VModalContent,
  },
  setup() {
    const { t } = useI18n();
    const { back } = useModalBack();
    const acceptedAnalytics = ref(false);

    const submit = () => {
      localStorage.setItem("acceptedCookies", "true");
      history.back();
      modalController.dismiss(null, "confirm");
    };

    const submitAll = async () => {
      if (GA_MEASUREMENT_ID) {
        await bootstrap();
      }
      acceptedAnalytics.value = true;
      localStorage.setItem("acceptedAnalytics", "true");
      localStorage.setItem("acceptedCookies", "true");
      history.back();
      modalController.dismiss(null, "confirm");
    };

    watch(acceptedAnalytics, (current) => {
      localStorage.setItem("acceptedAnalytics", String(current));
    });

    onMounted(() => {
      acceptedAnalytics.value = localStorage.getItem("acceptedAnalytics") === "true";
    });

    return { t, acceptedAnalytics, submit, submitAll, back };
  },
});
</script>

<style scoped></style>
